import React from 'react';
import { Link } from 'react-router-dom';
import { Users, Shield, MapPin, CheckCircle, Truck, Building } from 'lucide-react';
import { AnimatedSection } from '../components/AnimatedSection';
export function WorkshopsPage() {
  return <div className="w-full bg-warm-white" data-id="element-867">
      {/* A) HERO */}
      <div className="bg-primary-900 text-warm-white py-20 lg:py-28 relative overflow-hidden" data-id="element-868">
        <div className="absolute inset-0 opacity-20" data-id="element-869">
          <img src="https://images.unsplash.com/photo-1601758228041-f3b2795255f1?w=1200" alt="Group training session" className="w-full h-full object-cover" data-id="element-870" />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-871">
          <h1 className="text-4xl lg:text-6xl font-heading mb-6" data-id="element-872">
            Hands-On Workshops at Your Location
          </h1>
          <p className="text-xl text-primary-100 font-body max-w-2xl mx-auto" data-id="element-873">
            We bring professional pet CPR & first aid training directly to your
            home, business, or organization across the Bay Area.
          </p>
        </div>
      </div>

      {/* B) HOW IT WORKS */}
      <AnimatedSection className="py-24 bg-warm-white" data-id="element-874">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-875">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-876">
            <h2 className="text-3xl lg:text-4xl font-heading text-primary-900 mb-6" data-id="element-877">
              How Workshops Work
            </h2>
          </div>

          <div className="max-w-4xl mx-auto" data-id="element-878">
            <ul className="space-y-8 font-body text-warm-gray-700" data-id="element-879">
              <li className="flex items-start gap-4" data-id="element-880">
                <div className="bg-primary-100 text-primary-800 rounded-full w-10 h-10 flex items-center justify-center shrink-0 font-bold text-lg" data-id="element-881">
                  1
                </div>
                <div data-id="element-882">
                  <h3 className="text-xl font-heading text-primary-900 mb-2" data-id="element-883">
                    Tell Us About Your Group
                  </h3>
                  <p className="leading-relaxed" data-id="element-884">
                    Share your location, group size, and any specific needs.
                    We'll send a custom quote within 48 hours.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-885">
                <div className="bg-primary-100 text-primary-800 rounded-full w-10 h-10 flex items-center justify-center shrink-0 font-bold text-lg" data-id="element-886">
                  2
                </div>
                <div data-id="element-887">
                  <h3 className="text-xl font-heading text-primary-900 mb-2" data-id="element-888">
                    We Come to You
                  </h3>
                  <p className="leading-relaxed" data-id="element-889">
                    On training day, we arrive early to set up our mobile
                    classroom with mannequins and all equipment.
                  </p>
                </div>
              </li>
              <li className="flex items-start gap-4" data-id="element-890">
                <div className="bg-primary-100 text-primary-800 rounded-full w-10 h-10 flex items-center justify-center shrink-0 font-bold text-lg" data-id="element-891">
                  3
                </div>
                <div data-id="element-892">
                  <h3 className="text-xl font-heading text-primary-900 mb-2" data-id="element-893">
                    Learn, Practice, Get Certified
                  </h3>
                  <p className="leading-relaxed" data-id="element-894">
                    4 hours of hands-on training. Every participant leaves with
                    real skills and a certification.
                  </p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </AnimatedSection>

      {/* C) WHO IT'S FOR */}
      <AnimatedSection className="py-24 bg-warm-gray-50" data-id="element-895">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-896">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-897">
            <h2 className="text-3xl lg:text-4xl font-heading text-primary-900 mb-6" data-id="element-898">
              Built for Teams, Families & Organizations
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-899">
            <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-900">
              <Building className="w-10 h-10 text-accent-500 mb-4" data-id="element-901" />
              <h3 className="font-heading text-xl text-primary-900 mb-4" data-id="element-902">
                Pet Businesses
              </h3>
              <ul className="space-y-3 font-body text-warm-gray-600" data-id="element-903">
                <li className="flex items-center gap-2" data-id="element-904">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-905" />{' '}
                  Grooming salons
                </li>
                <li className="flex items-center gap-2" data-id="element-906">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-907" />{' '}
                  Daycare facilities
                </li>
                <li className="flex items-center gap-2" data-id="element-908">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-909" />{' '}
                  Boarding businesses
                </li>
                <li className="flex items-center gap-2" data-id="element-910">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-911" />{' '}
                  Dog training studios
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-912">
              <Users className="w-10 h-10 text-accent-500 mb-4" data-id="element-913" />
              <h3 className="font-heading text-xl text-primary-900 mb-4" data-id="element-914">
                Organizations
              </h3>
              <ul className="space-y-3 font-body text-warm-gray-600" data-id="element-915">
                <li className="flex items-center gap-2" data-id="element-916">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-917" />{' '}
                  Rescue groups
                </li>
                <li className="flex items-center gap-2" data-id="element-918">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-919" />{' '}
                  Veterinary clinics
                </li>
                <li className="flex items-center gap-2" data-id="element-920">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-921" />{' '}
                  Apartment communities
                </li>
                <li className="flex items-center gap-2" data-id="element-922">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-923" />{' '}
                  HOAs
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-924">
              <MapPin className="w-10 h-10 text-accent-500 mb-4" data-id="element-925" />
              <h3 className="font-heading text-xl text-primary-900 mb-4" data-id="element-926">
                Families & Individuals
              </h3>
              <ul className="space-y-3 font-body text-warm-gray-600" data-id="element-927">
                <li className="flex items-center gap-2" data-id="element-928">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-929" />{' '}
                  Pet owners
                </li>
                <li className="flex items-center gap-2" data-id="element-930">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-931" />{' '}
                  Multi-pet households
                </li>
                <li className="flex items-center gap-2" data-id="element-932">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-933" />{' '}
                  New puppy parents
                </li>
                <li className="flex items-center gap-2" data-id="element-934">
                  <CheckCircle className="w-4 h-4 text-accent-500 shrink-0" data-id="element-935" />{' '}
                  Pet sitters
                </li>
              </ul>
            </div>
          </div>
        </div>
      </AnimatedSection>

      {/* D) WHY ON-SITE */}
      <AnimatedSection className="py-24 bg-warm-white" data-id="element-936">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-937">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-938">
            <h2 className="text-3xl lg:text-4xl font-heading text-primary-900 mb-6" data-id="element-939">
              Why Train On-Site?
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-940">
            <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-941">
              <Shield className="w-10 h-10 text-accent-500 mb-4" data-id="element-942" />
              <h3 className="font-heading text-xl text-primary-900 mb-3" data-id="element-943">
                Risk Mitigation
              </h3>
              <p className="font-body text-warm-gray-600" data-id="element-944">
                Reduce liability and ensure your facility is prepared for the
                most common pet emergencies.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-945">
              <Truck className="w-10 h-10 text-accent-500 mb-4" data-id="element-946" />
              <h3 className="font-heading text-xl text-primary-900 mb-3" data-id="element-947">
                Zero Logistics
              </h3>
              <p className="font-body text-warm-gray-600" data-id="element-948">
                No need to coordinate off-site. We bring everything to your
                space.
              </p>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-warm border border-warm-gray-100" data-id="element-949">
              <MapPin className="w-10 h-10 text-accent-500 mb-4" data-id="element-950" />
              <h3 className="font-heading text-xl text-primary-900 mb-3" data-id="element-951">
                Client Trust
              </h3>
              <p className="font-body text-warm-gray-600" data-id="element-952">
                Market your business as "Pet CPR Certified" to stand out and
                give pet parents peace of mind.
              </p>
            </div>
          </div>
        </div>
      </AnimatedSection>

      {/* E) SERVICE AREA */}
      <AnimatedSection className="py-24 bg-warm-gray-50" data-id="element-953">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-954">
          <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-955">
            <h2 className="text-3xl lg:text-4xl font-heading text-primary-900 mb-4" data-id="element-956">
              Serving the Entire Bay Area
            </h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6 max-w-3xl mx-auto mb-10" data-id="element-957">
            {['San Jose', 'San Francisco', 'Oakland', 'Palo Alto', 'Mountain View', 'Sunnyvale', 'Santa Clara', 'Cupertino'].map((city, i) => <div key={i} className="bg-primary-50 p-4 rounded-xl text-center border border-primary-100" data-id="element-958">
                <MapPin className="w-5 h-5 text-primary-700 mx-auto mb-2" data-id="element-959" />
                <span className="font-body text-primary-900 font-medium text-sm" data-id="element-960">
                  {city}
                </span>
              </div>)}
          </div>

          <div className="text-center" data-id="element-961">
            <p className="font-body text-sm text-warm-gray-500 italic" data-id="element-962">
              *Travel fees may apply for locations more than 30 miles outside
              central San Francisco.
            </p>
          </div>
        </div>
      </AnimatedSection>

      {/* F) PRICING */}
      <AnimatedSection className="py-24 bg-primary-50" data-id="element-963">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-964">
          <div className="bg-white rounded-3xl shadow-warm-xl p-8 lg:p-12 border border-primary-100 max-w-4xl mx-auto" data-id="element-965">
            <h2 className="text-3xl font-heading text-primary-900 mb-6" data-id="element-966">
              Workshop Pricing
            </h2>
            <p className="font-body text-warm-gray-700 mb-6" data-id="element-967">
              Starting at $199 per group for the full 4-hour certification
              workshop. We offer tiered discounts based on the size of your
              group. All on-site group sessions include hands-on mannequin
              practice and individual certificates for every attendee.
            </p>
            <ul className="space-y-4 font-body text-warm-gray-700 mb-8" data-id="element-968">
              <li className="flex items-center justify-between border-b border-warm-gray-100 pb-2" data-id="element-969">
                <span className="font-medium" data-id="element-970">5 - 9 People</span>
                <span className="text-primary-800 font-bold" data-id="element-971">10% Off</span>
              </li>
              <li className="flex items-center justify-between border-b border-warm-gray-100 pb-2" data-id="element-972">
                <span className="font-medium" data-id="element-973">10 - 15 People</span>
                <span className="text-primary-800 font-bold" data-id="element-974">15% Off</span>
              </li>
              <li className="flex items-center justify-between border-b border-warm-gray-100 pb-2" data-id="element-975">
                <span className="font-medium" data-id="element-976">16+ People</span>
                <span className="text-primary-800 font-bold" data-id="element-977">Custom Quote</span>
              </li>
            </ul>
            <div className="bg-accent-50 p-4 rounded-xl border border-accent-100" data-id="element-978">
              <p className="font-body text-sm text-accent-800 flex items-start gap-2" data-id="element-979">
                <CheckCircle className="w-5 h-5 shrink-0 mt-0.5" data-id="element-980" />
                <span data-id="element-981">
                  Non-profit rescues and shelters are eligible for additional
                  community discounts. Please mention your 501(c)(3) status when
                  inquiring.
                </span>
              </p>
            </div>
          </div>
        </div>
      </AnimatedSection>

      {/* G) CTA */}
      <AnimatedSection className="py-24 bg-primary-800 text-center" data-id="element-982">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-983">
          <h2 className="text-3xl lg:text-4xl font-heading text-warm-white mb-6" data-id="element-984">
            Ready to Train Your Team?
          </h2>
          <p className="text-lg text-primary-100 font-body mb-8" data-id="element-985">
            Tell us about your group and we'll send a custom quote.
          </p>
          <Link to="/contact" className="inline-flex justify-center items-center px-8 py-4 border border-transparent text-lg font-bold rounded-full text-primary-900 bg-accent-500 hover:bg-accent-400 shadow-warm-lg transition-all hover:-translate-y-1" data-id="element-986">
            Request a Workshop
          </Link>
        </div>
      </AnimatedSection>
    </div>;
}